import { Container } from 'react-bootstrap';
import { NavLink as Link } from 'react-router-dom';
import { HashLink as hashLink } from 'react-router-hash-link';
import styled from 'styled-components';
import { SM_FONT_SIZE, XL_FONT_SIZE } from '../Common/StyleElement';

const max_width = '992px';

export const Nav = styled.nav`
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 3;
  height: 80px;
  font-size: ${SM_FONT_SIZE};
  background-color: $white-color;
  box-shadow: 0 1px 15px -4px rgba(0, 0, 0, 0.2);
`

export const NavContainer = styled(Container)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`

export const NavLogo = styled(Link)`
  color: #000;
  justify-self: flex-start;
  cursor: pointer;
  font-size: ${XL_FONT_SIZE};
  display: flex;
  align-items: center;
  font-weight: bold;
  text-decoration: none;
  z-index: 1;
  &:hover {
    color: #000;
  }
`

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: ${max_width}) {
    display: block;
    justify-self: end;
    font-size: 3rem;
    cursor: pointer;
    z-index: 1;

    svg {
      fill: #333;
    }
  }
`

export const NavMenu = styled.ul`
    display: flex;
    justify-self: flex-end;
    align-items: center;
    list-style: none;
    text-align: center;
    margin: 0;
    padding: 0;

    @media screen and (max-width: ${max_width}) {
      display: none;
    }
`

export const NavItem = styled.li`
  height: 80px;
`

export const NavLink = styled(hashLink)`
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    padding-left: 4rem;
    height: 100%;
    width: 100%;
    cursor: pointer;

    &:hover {
      color: #1861A6;
    }
`